import { Client } from '@shared/api/client';

export type TelemetryEventName = 'SessionEnded' | 'PageNavigated' | 'ProductAdded' | 'SystemAdded';

export interface TelemetryEvent {
  eventName: TelemetryEventName;
  [key: string]: unknown;
}

const ENDPOINT_MAP: Record<string, string> = {
  SessionEnded: '/functions/TrackSessionEnded',
  PageNavigated: '/functions/TrackPageNavigated',
  ProductAdded: '/functions/TrackProductAdded',
  SystemAdded: '/functions/TrackSystemAdded',
};

const client = new Client();

export function sendTelemetryEvent(event: TelemetryEvent): Promise<void> {
  const endpoint = ENDPOINT_MAP[event.eventName];
  if (!endpoint) {
    return Promise.reject(new Error(`Unknown telemetry event: ${event.eventName}`));
  }

  const { eventName, ...payload } = event;
  return client.makeRequest<void>(endpoint, {
    method: 'POST',
    content: payload,
  });
}
